import { LabReqTemplate } from '@care-portals/api-interfaces';
import {
  biochemistryFields,
  hematologyFields,
  immunologyFields,
  microbiologyFields,
  otherTestsFields,
  psaFields,
  viralFields,
  vitaminFields
} from './on-data';
import { insuranceTypeFields } from './data';

export const labReqTemplates: Array<LabReqTemplate> = [
  {
    id: 'trt1on',
    label: 'TRT1 ON',
    description: 'Ontario Lab Req',
    brand: 'jack-health',
    allowAdditionalTests: true,
    tests: [
      {
        id: 'urgentContactNumber',
        label: "Clinician/Practitioner's Contact Number for Urgent Results",
        options: [
          {
            type: 'string',
            id: 'contactNumber',
            label: 'Contact Number',
            required: true
          }
        ]
      },
      // {
      //   id: 'ohip',
      //   label: 'Check one',
      //   options: [
      //     {
      //       type: 'boolean',
      //       id: 'ohip',
      //       label: 'OHIP/Insured'
      //     },
      //     {
      //       type: 'boolean',
      //       id: 'thirdParty',
      //       label: 'Third Party / Uninsured'
      //     },
      //     { type: 'boolean', id: 'wsib', label: 'WSIB' }
      //   ]
      // },
      // {
      //   id: 'sex',
      //   label: 'Sex',
      //   options: [
      //     { type: 'boolean', id: 'male', label: 'M' },
      //     { type: 'boolean', id: 'female', label: 'F' }
      //   ]
      // },
      {
        id: 'insuranceType',
        label: 'Insurance Type',
        options: insuranceTypeFields
      },
      {
        id: 'biochemistry',
        label: 'Biochemistry',
        options: biochemistryFields
      },
      {
        id: 'hematology',
        label: 'Hematology',
        options: hematologyFields
      },
      {
        id: 'immunology',
        label: 'Immunology',
        options: immunologyFields
      },
      {
        id: 'microbiology',
        label: 'Microbiology ID & Sensitivities',
        options: microbiologyFields
      },
      {
        id: 'viralHepatitis',
        label: 'Viral Hepatitis (check one only)',
        options: viralFields
      },
      {
        id: 'psa',
        label: 'Prostate Specific Antigen (PSA)',
        options: psaFields
      },
      {
        id: 'vitaminD',
        label: 'Vitamin D (25-Hydroxy)',
        options: vitaminFields
      },
      {
        id: 'otherTests',
        label: 'Other Tests - one test per line',
        options: otherTestsFields
      }
    ]
  },
  {
    id: 'wlon',
    label: 'WL ON',
    description: 'Ontario Lab Req',
    brand: 'jack-health',
    allowAdditionalTests: true,
    tests: [
      {
        id: 'urgentContactNumber',
        label: "Clinician/Practitioner's Contact Number for Urgent Results",
        options: [
          {
            type: 'string',
            id: 'contactNumber',
            label: 'Contact Number',
            required: true
          }
        ]
      },
      // {
      //   id: 'ohip',
      //   label: 'Check one',
      //   options: [
      //     {
      //       type: 'boolean',
      //       id: 'ohip',
      //       label: 'OHIP/Insured'
      //     },
      //     {
      //       type: 'boolean',
      //       id: 'thirdParty',
      //       label: 'Third Party / Uninsured'
      //     },
      //     { type: 'boolean', id: 'wsib', label: 'WSIB' }
      //   ]
      // },
      // {
      //   id: 'sex',
      //   label: 'Sex',
      //   options: [
      //     { type: 'boolean', id: 'male', label: 'M' },
      //     { type: 'boolean', id: 'female', label: 'F' }
      //   ]
      // },
      {
        id: 'insuranceType',
        label: 'Insurance Type',
        options: insuranceTypeFields
      },
      {
        id: 'biochemistry',
        label: 'Biochemistry',
        options: biochemistryFields
      },
      {
        id: 'hematology',
        label: 'Hematology',
        options: hematologyFields
      },
      {
        id: 'immunology',
        label: 'Immunology',
        options: immunologyFields
      },
      {
        id: 'microbiology',
        label: 'Microbiology ID & Sensitivities',
        options: microbiologyFields
      },
      {
        id: 'viralHepatitis',
        label: 'Viral Hepatitis (check one only)',
        options: viralFields
      },
      {
        id: 'psa',
        label: 'Prostate Specific Antigen (PSA)',
        options: psaFields
      },
      {
        id: 'vitaminD',
        label: 'Vitamin D (25-Hydroxy)',
        options: vitaminFields
      },
      {
        id: 'otherTests',
        label: 'Other Tests - one test per line',
        options: otherTestsFields
      }
    ]
  },
  {
    id: 'lgvon',
    label: 'LGV ON',
    description: 'Ontario Longevity Lab Req',
    brand: 'jack-health',
    allowAdditionalTests: true,
    tests: [
      {
        id: 'urgentContactNumber',
        label: "Clinician/Practitioner's Contact Number for Urgent Results",
        options: [
          {
            type: 'string',
            id: 'contactNumber',
            label: 'Contact Number',
            required: true
          }
        ]
      },
      {
        id: 'insuranceType',
        label: 'Insurance Type',
        options: insuranceTypeFields
      },
      {
        id: 'biochemistry',
        label: 'Biochemistry',
        options: biochemistryFields
      },
      {
        id: 'hematology',
        label: 'Hematology',
        options: hematologyFields
      },
      {
        id: 'immunology',
        label: 'Immunology',
        options: immunologyFields
      },
      {
        id: 'microbiology',
        label: 'Microbiology ID & Sensitivities',
        options: microbiologyFields
      },
      {
        id: 'viralHepatitis',
        label: 'Viral Hepatitis (check one only)',
        options: viralFields
      },
      {
        id: 'psa',
        label: 'Prostate Specific Antigen (PSA)',
        options: psaFields
      },
      {
        id: 'vitaminD',
        label: 'Vitamin D (25-Hydroxy)',
        options: vitaminFields
      },
      {
        id: 'otherTests',
        label: 'Other Tests - one test per line',
        options: otherTestsFields
      }
    ]
  },
  {
    id: 'on',
    variant: 'lgv_paid',
    label: 'ON LGV (Paid)',
    description: 'Ontario LGV Lab Req - LifeLabs Contract (AX613)',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'test',
    label: 'Test',
    description: 'Ontario Lab Req',
    brand: 'jack-health',
    allowAdditionalTests: true,
    tests: [
      {
        id: 'dob',
        label: 'Date of Birth',
        options: [
          { type: 'number', id: 'year', label: 'Year', required: true },
          { type: 'number', id: 'month', label: 'Month', required: true },
          { type: 'number', id: 'day', label: 'Day', required: true }
        ]
      },
      {
        id: 'address',
        label: 'Address',
        options: [{ type: 'string', id: 'address', label: 'Address' }]
      },
      {
        id: 'sex',
        label: 'Sex',
        options: [
          { type: 'boolean', id: 'male', label: 'Male' },
          { type: 'boolean', id: 'female', label: 'Female' }
        ]
      }
    ]
  },
  {
    id: 'bc',
    label: 'BC',
    description: 'British Columbia Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'bc',
    variant: 'trt',
    label: 'BC TRT',
    description: 'British Columbia TRT Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'bc',
    variant: 'wl',
    label: 'BC WL',
    description: 'British Columbia WL Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'bc',
    variant: 'lgv',
    label: 'BC LGV',
    description: 'British Columbia Longevity Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'bc',
    variant: 'lgv_paid',
    label: 'BC LGV (Paid)',
    description: 'British Columbia LGV Lab Req - LifeLabs Contract (A7339)',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'ab',
    label: 'AB',
    description: 'Alberta Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'ab',
    variant: 'trt',
    label: 'AB TRT',
    description: 'Alberta TRT Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'ab',
    variant: 'wl',
    label: 'AB WL',
    description: 'Alberta WL Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'ab',
    variant: 'lgv',
    label: 'AB LGV',
    description: 'Alberta Longevity Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'qc',
    label: 'QC',
    description: 'Quebec Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'qc',
    variant: 'wl',
    label: 'QC WL',
    description: 'Quebec Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'qc',
    variant: 'trt',
    label: 'QC TRT',
    description: 'Quebec Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'qc',
    variant: 'lgv',
    label: 'QC LGV',
    description: 'Quebec Longevity Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'sk',
    label: 'SK',
    description: 'Saskatchewan Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'sk',
    variant: 'wl',
    label: 'SK WL',
    description: 'Saskatchewan Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'sk',
    variant: 'trt',
    label: 'SK TRT',
    description: 'Saskatchewan Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'sk',
    variant: 'lgv',
    label: 'SK LGV',
    description: 'Saskatchewan Longevity Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'sk',
    variant: 'lgv_paid',
    label: 'SK LGV (Paid)',
    description: 'Saskatchewan LGV Lab Req - LifeLabs Contract (AX614)',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'nf',
    variant: 'trt',
    label: 'NF TRT',
    description: 'Newfoundland Lab Req',
    brand: 'jack-health',
    v: 2
  },
  {
    id: 'nf',
    variant: 'lgv',
    label: 'NF LGV',
    description: 'Newfoundland Longevity Lab Req',
    brand: 'jack-health',
    v: 2
  }
];
